import ReactDOM from "react-dom";
import Footer from "../components/Footer";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderFooter = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<Footer props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering Footer:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
